import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const CARDS = [
  {
    icon: "🎯",
    color: "var(--neon-blue)",
    title: "SET THE STAKES",
    body: "The Admin picks daily family habits and locks in the ultimate weekly reward.",
  },
  {
    icon: "📸",
    color: "var(--neon-pink)",
    title: "LOG & PROVE",
    body: "Enter your profile PIN daily, mark your status, and post photo evidence.",
  },
  {
    icon: "🏆",
    color: "var(--stakes-admin)",
    title: "WIN THE POT",
    body: "Track the live leaderboard. Highest points wins — losers pay the stakes!",
  },
];

export default function HowToPlayModal({ open, onClose }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        className="max-w-5xl w-[96vw] max-h-[92vh] overflow-y-auto bg-[var(--stakes-bg)] border-2 rounded-none p-0 [&>button]:hidden"
        style={{ borderImage: "linear-gradient(90deg, var(--neon-blue), var(--neon-pink)) 1" }}
        data-testid="how-to-play-modal"
      >
        <DialogTitle className="sr-only">How to play STAKES</DialogTitle>
        <DialogDescription className="sr-only">Three-step guide</DialogDescription>

        <div className="px-6 md:px-10 pt-8 pb-2">
          <div className="label-mono" style={{ color: "var(--neon-blue)" }}>HOW TO PLAY</div>
          <h2 className="font-montserrat text-4xl sm:text-5xl md:text-6xl uppercase mt-2 leading-[0.9]">
            <span className="brand-wordmark">3 RULES.</span><br/>
            <span className="text-white">ONE WINNER.</span>
          </h2>
          <p className="font-barlow text-lg md:text-xl text-[var(--stakes-muted)] uppercase mt-3 max-w-2xl">
            STAKES is a family habit league. Earn points by completing daily habits, prove it with photos,
            and outscore everyone before the month ends.
          </p>
        </div>

        <div className="grid gap-5 md:grid-cols-3 px-6 md:px-10 pb-10 pt-6">
          {CARDS.map((c, i) => (
            <div
              key={c.title}
              className="relative border-2 p-6 bg-[var(--stakes-surface)] overflow-hidden animate-slide-up"
              style={{
                borderColor: c.color,
                boxShadow: `0 0 0 0 transparent, inset 0 0 60px ${c.color}1A`,
                animationDelay: `${i * 80}ms`,
              }}
              data-testid={`htp-card-${i}`}
            >
              <div
                className="absolute -top-12 -right-10 w-40 h-40 rounded-full opacity-20"
                style={{ background: `radial-gradient(circle, ${c.color}, transparent 70%)` }}
              />
              <div
                className="text-6xl mb-3 relative z-10"
                style={{ filter: `drop-shadow(0 0 18px ${c.color}AA)` }}
              >
                {c.icon}
              </div>
              <div className="label-mono relative z-10" style={{ color: c.color }}>
                STEP {String(i + 1).padStart(2, "0")}
              </div>
              <h3 className="font-anton text-3xl uppercase mt-1 relative z-10 leading-none">{c.title}</h3>
              <p className="font-barlow text-lg uppercase mt-3 relative z-10 text-white wrap-words leading-snug">
                {c.body}
              </p>
            </div>
          ))}
        </div>

        <div className="px-6 md:px-10 pb-8">
          <button
            onClick={onClose}
            className="w-full h-14 btn-neon-blue font-montserrat uppercase text-xl tracking-wider"
            data-testid="htp-close-button"
          >
            LET&apos;S GO →
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
